import { render, staticRenderFns } from "./AverageTreatmentByAge.vue?vue&type=template&id=9de33300&"
import script from "./AverageTreatmentByAge.vue?vue&type=script&lang=js&"
export * from "./AverageTreatmentByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports